/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshTokenDto } from '../../models/refresh-token-dto';
import { SessionDto } from '../../models/session-dto';

export interface AuthControllerRefreshToken$Params {
      body: RefreshTokenDto
}

export function authControllerRefreshToken(http: HttpClient, rootUrl: string, params: AuthControllerRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerRefreshToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SessionDto>;
    })
  );
}

authControllerRefreshToken.PATH = '/auth/refresh';
